import React from "react";
import "./index.css"; // Import CSS for styling
import PropTypes from "prop-types";

const ChaloInputField = ({
    label,
    placeholder,
    type = "text",
    value,
    onChange,
    name,
    disabled = false,
    id = '',
    error = false
}) => {
    return (
        <div className={`cInput-container ${disabled ? "cInput-field-disabled" : ""} ${error ? "border-red" : ""}`}> 
        {label && value &&(
            <label className="cInput-label" htmlFor={id}>
            {label} <span className="cRequired">*</span>
            </label>
        )}
        <input
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`cInput-field ${value ? "cInput-position" : ""}`}
            id={id}
            autoComplete="off"
        />
    </div>
    );
};

export default ChaloInputField;


ChaloInputField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.bool,
};

